import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormState } from '../../states/investigation-form.state';
import { AddFieldCommand } from './add-field.command';

@Injectable({ providedIn: 'root' })
export class AddFieldUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);

  public execute(command: AddFieldCommand): Observable<{ id: string }> {
    this._state.setLoadingInvestigationForm(true);
    this._state.clearErrorInvestigationForms();

    return this._repository.addField(command.versionId, command.field).pipe(
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to add field to version ${command.versionId}`;
        this._state.setErrorInvestigationForms(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingInvestigationForm(false))
    );
  }
}
